import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Collapse} from "reactstrap";
import classNames from 'classnames';


export default class CollapsedCard extends Component {
    constructor(props) {
        super(props);
        this.toggleExpanded = this.toggleExpanded.bind(this);

        this.state = {
            expanded: props.expanded || false
        };
    }

    toggleExpanded(e) {
        e.preventDefault();
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        // console.log('collapsed card props', this.props);
        return (
            <Card className="card-bordered collapsible-card mb-4">
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <h4>{this.props.header}</h4>
                        <a className={classNames("card-collapse-btn", {collapsed: !this.state.expanded})} href="#" onClick={this.toggleExpanded} />
                    </div>
                </CardHeader>
                <Collapse isOpen={this.state.expanded}>
                    <CardBody>
                        {this.props.children}
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}

CollapsedCard.propTypes = {
    header: PropTypes.string.isRequired,
    children: PropTypes.node
};
